<template>
  <config-base ref="baseRef" :on="$listeners" show-plan-details v-bind="$props">
    <template #config>
      <capacity-config-list :config-plan-type="planType" :config-capacity-key="capacityKey"></capacity-config-list>
    </template>
    <template #footer v-if="canRmv">
      <zm-button type="link" ghost @click="removePlanByKey" :aria-label="'remove ' + trackingPlanKey + ' plan'">{{ $t('billing.common.remove') }}</zm-button>
    </template>
  </config-base>
</template>

<script>
import planCommon from '@/plans/WEBINAR/mixin';
import {getPlanTotalLicense} from "@/common/service/validate";
import plansMixin from "@/plans/mx/plan";
import ConfigList from "@/components/capacity/config-list.vue";
import ConfigBase from "@/plans/WEBINAR/config/base.vue";
import { computedCapacityWebinarPlans } from "@/common/service/computers/plans/webinar";
import PlanDetailsMixin from '@/plans/EVENT_SAAS/component/dialog/plan-details/mx-plan-details';
import { planTypes } from '@/common/constants';
import { isBizPlusContext, isBuyingWnE } from '@/plans/ZOOM_MEETING/common/utils';
import { mapGetters, mapMutations } from 'vuex';
import autoAddMixin from "@/components/capacity/mx/autoAdd";
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';
import _ from 'lodash';
const CapacityConfigList = {
  name: 'CapacityConfigList',
  extends: ConfigList,
  mixins: [planCommon, PlanDetailsMixin ,autoAddMixin],
  computed: {
    ...mapGetters(['getSelectedPlans']),
    addAnotherCapacityCta() {
      return this.$t('billing.addAnother.webinar');
    },
  },
  methods: {
    mx_getMaxHosts() {
      if (isBizPlusContext) {
        return getPlanTotalLicense(this.getSelectedPlans.filter(item => [planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE].includes(item.type))) || 999;
      }
      const targetPlans = this.planMapFlat.filter((item) => (item.type === planTypes.ZOOM_MEETING) & (item.category === ZOOM_MEETING_SUB_TYPES.BIZ));
      const { max } = _.get(targetPlans, '0', { max: 1, min: 99 }) || 250;
      if (isBuyingWnE(this.getSelectedPlans)) return max;
      return getPlanTotalLicense(this.getCurrentBasePlanInfo?.plans) || 999;
    },
    mx_getIncreaseTips(capacity, license) {
      const currentCapacityPlanCount = getPlanTotalLicense(computedCapacityWebinarPlans(this.selectedPlanList || [], capacity)) || license;
      return currentCapacityPlanCount >= this.mx_getMaxHosts() ? this.totalLimitDesc : '';
    },
    mx_onBasePlanUpdated(basePlanName) {
      this.mx_showMessage(
        this.$t('billing.license_sync_base', [basePlanName,this.$t('billing.webinar.title')]),
      );
    },
    mx_onSelectedPlanUpdated(basePlanName) {
      this.mx_showMessage(
        this.$t('billing.license_sync_base', [this.$t('billing.webinar.title'),basePlanName]),
      );
    },
    handleLicenseChange(license){
        if (!this.mx_canAutoAdd) return;
        this.mx_handlePlanLicenseChange(license)
    }
  },
  watch: {
    getSelectedPlans: {
      immediate: true,
      handler(n,o) {
        if(n?.length > o?.length ){
          if (!this.mx_canAutoAdd) return;
          const num = this.findUpdatedPlan(n,o)
          num && this.mx_handlePlanLicenseChange(num)
        }
      },
    },
  }
}
export default {
  mixins: [plansMixin, planCommon ,autoAddMixin ],
  components: { ConfigBase, CapacityConfigList},
  computed:{
    canRmv() {
      return this.$context.type !== planTypes.WEBINAR
    },
  },
  methods:{
    ...mapMutations(['updateSelectPlanByCategory']),
  },
};
</script>

<style lang="scss">
</style>
